import { parseGeometryColor } from '@trimble/web3d-plugin-features-service';
import { isLayerLineStyle, type LayerLineStyle } from './layer-template';

/** `#rrggbb` from a packed ARGB integer or an RGB/ARGB hex string. */
export function parseLayerColor(value: unknown): string | undefined {
  if (
    typeof value === 'string' ||
    (typeof value === 'number' && Number.isFinite(value))
  ) {
    return parseGeometryColor(value)?.color;
  }
  return undefined;
}

export function parseLayerLineStyle(
  value: unknown
): LayerLineStyle | undefined {
  const normalized = typeof value === 'string' ? value.toLowerCase() : '';
  return isLayerLineStyle(normalized) ? normalized : undefined;
}

export function parseLayerLineWeight(value: unknown): number | undefined {
  return typeof value === 'number' && Number.isFinite(value) && value > 0
    ? value
    : undefined;
}
